export default "__VITE_ASSET__C3nqJ9rz__"